module.exports = __webpack_public_path__ + "static/media/f047cc2b-31a4-4408-8cf0-daaca8f62c3e.1392d68a.JPG";